export default __webpack_public_path__ + "static/dacha-license-4-fce1a0ef2fb141947e34eb36d37ca113.png";